var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"AlgoliaHits grid grid--medium"},_vm._l((_vm.filteredItems),function(item){return _c('li',{key:item.objectID,staticClass:"grid__item smart-one-whole one-half lap-and-up-one-third"},[_c('AlgoliaSearchHit',{attrs:{"item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }